function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fee187"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc61b"
    },
    d: "M506.697 308.057 389.079 190.438 226.263 207.3l-17.287-18.044-131.226 9.467 288.585 288.335c71.068-33.997 124.004-99.81 140.362-179.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "m322.931 307.607 30.089 30.091v-90.271h-30.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e09112"
    },
    d: "M196.644 164.907v60.18l60.18 60.18h90.271v48.935c0 6.211-5.036 11.245-11.245 11.245h-3.799c-8.309 0-15.045 6.735-15.045 15.045 0 8.309 6.735 15.045 15.045 15.045h60.18c8.309 0 15.045-6.735 15.045-15.045V239.068c0-40.958-33.202-74.161-74.161-74.161H196.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5419"
    },
    d: "M333.112 164.907h-46.368v120.36h60.349v48.935c0 6.211-5.036 11.245-11.245 11.245h-3.799c-8.309 0-15.045 6.735-15.045 15.045 0 8.309 6.735 15.045 15.045 15.045h60.18c8.309 0 15.045-6.735 15.045-15.045V239.066c-.001-40.956-33.204-74.159-74.162-74.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M407.273 345.447H393.14c-8.813 0-15.956-7.144-15.956-15.956v-58.356c0-8.813 7.144-15.956 15.956-15.956h14.133v90.268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a6a8aa"
    },
    d: "M161.082 200.468H81.755a5.472 5.472 0 0 1 0-10.944h79.327a5.473 5.473 0 0 1 0 10.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808183"
    },
    d: "M76.333 194.513c-.014.162-.048.317-.048.484 0 3.02 2.45 5.47 5.472 5.47h79.326a5.472 5.472 0 0 0 5.472-5.47c0-.165-.034-.322-.048-.484H76.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#808183"
    },
    d: "M196.644 225.087H153.94c-9.652 0-17.477-7.825-17.477-17.477v-25.226c0-9.652 7.825-17.477 17.477-17.477h42.703v60.18h.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595b"
    },
    d: "M136.464 194.513v13.097c0 9.652 7.825 17.477 17.477 17.477h42.703v-30.573h-60.18v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595b"
    },
    d: "M166.547 164.909h30.091v60.18h-30.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M166.547 194.508h30.091v30.573h-30.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595b"
    },
    d: "M312.444 210.042h-51.062a4.56 4.56 0 1 1 0-9.12h51.062a4.56 4.56 0 1 1 0 9.12zM312.444 194.998h-51.062a4.56 4.56 0 1 1 0-9.12h51.062a4.56 4.56 0 1 1 0 9.12zM312.444 225.087h-51.062a4.56 4.56 0 1 1 0-9.12h51.062a4.56 4.56 0 1 1 0 9.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M312.444 200.925h-25.7v9.118h25.7a4.56 4.56 0 1 0 0-9.118zM312.444 185.878h-25.7v9.119h25.7a4.56 4.56 0 1 0 0-9.119zM312.444 215.969h-25.7v9.118h25.7a4.56 4.56 0 1 0 0-9.118z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriller);
export default __webpack_public_path__ + "static/media/driller.1995b4a86a6e1c5ff5fb17041e0a3425.svg";
export { ForwardRef as ReactComponent };